// import hooks
import { useState } from "react";
import useSearchResults from "./useSearchResults.js";
export const useSearchInput = ({ onClear, onSubmit, closeOnSubmit, close, }) => {
    const { setQuery, queries } = useSearchResults();
    const [searchFieldKey, _setSearchFieldKey] = useState(crypto.randomUUID());
    const clear = () => {
        _setSearchFieldKey(crypto.randomUUID());
        onClear();
    };
    const submitHandler = (query) => {
        if (!query?.trim())
            return;
        setQuery(query);
        onSubmit?.(query, clear);
        if (closeOnSubmit)
            close();
    };
    return {
        setQuery,
        searchFieldKey,
        clear,
        submitHandler,
        queries: queries
            .map((query) => ({
            id: query,
            label: query,
            payload: () => submitHandler(query),
        }))
            .reverse(),
    };
};
export default useSearchInput;
